<div class="flex items-center justify-between">
  <h3 class="flex-1">Properties {{ itemsForLabel ? 'for ' + itemsForLabel : '' }}</h3>
  <sbnb-close (click)="close()"></sbnb-close>
</div>
<div class="mt-6 flex flex-col gap-4">
  @for (item of items; track item.id) {
    <div
      class="flex items-center gap-2"
      [routerLink]="getItemLink(item)"
      [class.link-emphasized]="itemLink && item?.id"
      (click)="itemLink && item?.id && close()">
      <img [src]="item.picture" class="w-7 h-7 rounded-full" />
      <span>{{ item.name }}</span>
    </div>
  }
</div>
